import * as React from 'react';
import { format } from 'owa-strings';
import { FullOptionsLink } from 'owa-options-link';
import { getUserConfiguration } from 'owa-session-store';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-weather-strings';

const styles = require('./AgendaMailFull.scss');

@observer
export default class Weather extends React.Component<{}, {}> {
    render() {
        const weatherLocations = getUserConfiguration().UserOptions.WeatherLocations;
        let weatherLocation: string =
            weatherLocations && weatherLocations.length ? weatherLocations[0].Name : null;

        return (
            <div className={styles.settingsContainer}>
                <span className={styles.settingsDescription}>
                    {format(strings.currentWeatherLocationLabel, weatherLocation)}
                </span>
                <FullOptionsLink category="calendar" subcategory="weather">
                    {strings.updateWeatherSettingsLinkText}
                </FullOptionsLink>
            </div>
        );
    }
}
